import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import * as S from './styles';
import { IProps } from './types';
import { Row, Col, ProgressBar } from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Input } from '@atoms';
import { meForReferral } from './__generated__/meForReferral';
import { ME_FOR_REFERRAL } from './queries';
import { Loading } from '@atoms';
import { useAlert } from 'react-alert';

const SharePage: React.FC<IProps> = ({}: // destructure props here if needed
IProps) => {
  const alert = useAlert();
  const { data, error, loading } = useQuery<meForReferral>(ME_FOR_REFERRAL);

  const [copyResult, setCopyResult] = useState(false);
  const handleOnCopy = () => {
    setCopyResult(true);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    data && (
      <S.Wrapper>
        <S.ShareContainer>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <S.ShareTitle>Share your invite link</S.ShareTitle>
              <S.ShareSubtitle>My referral code: {data.me?.referral?.code}</S.ShareSubtitle>
              <Row>
                <Col md={{ span: 6, offset: 3 }}>
                  <Input value={`https://maccaron.in/en/account/invite/` + data.me?.referral?.code} disabled={true} />
                  <CopyToClipboard
                    onCopy={handleOnCopy}
                    text={`https://maccaron.in/en/account/invite/` + data.me?.referral?.code}
                  >
                    <S.ClickToCopyText>Click to Copy</S.ClickToCopyText>
                  </CopyToClipboard>
                  {copyResult ? <S.CopyResult>Copied!</S.CopyResult> : null}
                </Col>
              </Row>
              <S.ShareTitle>Your invites</S.ShareTitle>
              <Row>
                <Col md={{ span: 6, offset: 3 }}>
                  <S.ReceivedPoint>
                    {data.me?.referralPoint?.amount || 0} /{' '}
                    {data.shop?.referralPointAmount * data.shop?.referralPointLimit} Points
                  </S.ReceivedPoint>
                  <ProgressBar
                    variant="custom"
                    now={
                      ((data.me?.referralPoint?.amount || 0) /
                        (data.shop?.referralPointAmount * data.shop?.referralPointLimit)) *
                      100
                    }
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </S.ShareContainer>
        <S.ShareContainer>
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <S.TncHeader>Terms & Conditions</S.TncHeader>
              <S.TncContent>
                <li>
                  We do not allow duplicate mobile numbers at the time of registering. Each friend should be a unique
                  account.
                </li>
                <li>
                  Points can be used at all times on the Maccaron website, unless mentioned in an event T&amp;C to not
                  use it.
                </li>
              </S.TncContent>
            </Col>
          </Row>
        </S.ShareContainer>
      </S.Wrapper>
    )
  );
};

export { SharePage };
